// Fester +-Knopf unter 768 px (UX-Vorschlag P7): öffnet die globale
// Schnellerfassung (P2), vorbelegt mit dem Kontext der Seite — Projekt,
// Liste; auf Mein Tag wird die neue Aufgabe für heute eingeplant. Welche Seiten ihn bekommen, entscheidet
// lib/capture.ts → fabPrefill(). EIN Mount in App.tsx statt je Seite, damit
// keine fremde Seite angefasst werden muss.

import { Plus } from "lucide-preact";
import { useLocation } from "wouter-preact";
import { fabPrefill } from "../lib/capture";
import { useProjects } from "../store/projects";
import { useLists } from "../store/personalTasks";
import { openCapture } from "../store/capture";
import { localTodayIso } from "../lib/format";

export function MobileCaptureFab(): preact.JSX.Element | null {
  const [location] = useLocation();
  const projects = useProjects();
  const { lists } = useLists();
  const prefill = fabPrefill(location, projects.items, lists);
  if (prefill === null) return null;
  return (
    <button
      type="button"
      onClick={() =>
        openCapture(prefill, /^\/today\/?$/.test(location) ? { myDay: localTodayIso() } : {})
      }
      class="md:hidden fixed right-4 z-30 bottom-[calc(env(safe-area-inset-bottom)+4.5rem)] inline-flex h-14 w-14 items-center justify-center rounded-full bg-[color:var(--color-primary)] text-[color:var(--color-on-primary)] shadow-level-3 focus:outline-none focus-visible:ring-2 focus-visible:ring-[color:var(--color-primary)] focus-visible:ring-offset-2"
      aria-label="Aufgabe erfassen"
      data-testid="mobile-capture-fab"
    >
      <Plus size={24} aria-hidden="true" />
    </button>
  );
}
